import GreenButton from '../../components/green-button';
import {useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import {closePromotionModal, clickPromotionModal} from '../../../utils/promotions';
import ModalsLib from '../../../lib/modals';

export default ({index}) => {
    const dispatch = useDispatch();

    // Refs
    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__slideInUp');
            modal.current.classList.add('animate__slideOutDown');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal('cashapp-available'));
            
            if(trigger === 'close')
                closePromotionModal('cashapp-available');
            else
                clickPromotionModal('cashapp-available', callback);
        }, 500);
    }
    
    return (
        <div className="action-modal-fix cashapp-available">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className="action-modal animate__animated animate__slideInUp animate__faster" ref={modal}>
                    <div className="action-modal-body-container">
                        <div className="action-modal-body-top">
                            <div className="close" onClick={e => closeAction('close')}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <div className="action-modal-body">
                            <div className="cashapp-available-title"><span>CashApp</span> available now!</div>
                            <div className="cashapp-available-image"></div>
                            <GreenButton  onClick={e => {
                                closeAction('click', () => {
                                    ModalsLib.open('wallet');
                                });
                            }}>Deposit</GreenButton>
                            <div className="description">Make a deposit and cash out just in one click</div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
}